import { render, staticRenderFns } from "./UpdateExtra.vue?vue&type=template&id=eb6e0c02"
import script from "./UpdateExtra.vue?vue&type=script&lang=ts"
export * from "./UpdateExtra.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports